import { Grid } from '~/components/Layout/GridCompat';
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

import { ChataiConversationDrawerOpenButton } from './ChataiConversationDrawerOpenButton'

export function ChataiConversationDrawerActions() {
  const theme = useTheme()

  return (
    <Grid
      container
      columnSpacing={1}
      sx={{
        p: 1,
        position: 'sticky',
        zIndex: 1,
        top: 0,
        backgroundColor: theme.palette.standard.light
      }}>
      <Grid sx={{
        flexGrow: 1
      }}>
        <Typography
          variant="body2"
          sx={{
            p: 1,
            fontWeight: 'bold'
          }}>
          機能一覧
        </Typography>
      </Grid>
      <Grid>
        <ChataiConversationDrawerOpenButton />
      </Grid>
    </Grid>
  );
}
